import { SegmentedCard, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { Section } from '@hero/atoms';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  position: relative;

  ${Section.S.SectionWrapper} {
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    min-height: 402px;
    padding-top: 48px;
    width: 100%;
  }
`;

const TabDescription = styled(Typography)`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: space-between;
  min-width: 300px;
  width: 100%;
`;

const TabDescriptionText = styled(Typography)`
  background: var(--color-accent-secondary-weakest);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  color: var(--color-neutral-500);
  display: flex;
  gap: 8px;
  margin-top: 8px;
  padding: 8px;
  width: 100%;
`;

const Content = styled.div`
  ${SegmentedCard.S.SegmentedCardOptions} {
    gap: 16px;
  }

  ${SegmentedCard.S.SegmentedCardItemBody}, ${SegmentedCard.S.SegmentedCardItemDescription} {
    width: 100%;
  }

  max-width: 880px;
  width: 100%;
`;

export { Content, TabDescription, TabDescriptionText, Wrapper };
